/**
 * Puntos del carrusel "huelen parecido".
 *
 * Un punto por PÁGINA, no por producto: con diez productos y cuatro visibles,
 * diez puntos no le dirían nada a nadie. Se calcula cuántas páginas caben con
 * el ancho real del carril, así que el número se ajuste solo al pasar de
 * escritorio a móvil.
 *
 * El desplazamiento con el dedo o el trackpad ya funciona sin esto: los puntos
 * son sólo una ayuda visual y un atajo para saltar de página.
 */
(function () {
  var carruseles = document.querySelectorAll("[data-ma-aroma]");
  if (!carruseles.length) return;

  carruseles.forEach(function (raiz) {
    var track = raiz.querySelector("[data-ma-aroma-track]");
    var cont = raiz.querySelector("[data-ma-aroma-dots]");
    if (!track || !cont) return;

    var puntos = [];

    function paginas() {
      var total = track.scrollWidth;
      var visible = track.clientWidth;
      if (visible <= 0) return 1;
      return Math.max(1, Math.ceil(total / visible));
    }

    function pintar() {
      var n = paginas();

      // Rehacer los puntos sólo si cambió el número de páginas.
      if (puntos.length !== n) {
        while (cont.firstChild) cont.removeChild(cont.firstChild);
        puntos = [];
        if (n < 2) return;
        for (var i = 0; i < n; i++) {
          (function (indice) {
            var b = document.createElement("button");
            b.type = "button";
            b.className = "ma-aroma__dot";
            b.setAttribute("aria-label", "Ver grupo " + (indice + 1) + " de " + n);
            b.addEventListener("click", function () {
              track.scrollTo({ left: indice * track.clientWidth, behavior: "smooth" });
            });
            cont.appendChild(b);
            puntos.push(b);
          })(i);
        }
      }
      if (!puntos.length) return;

      var actual = Math.round(track.scrollLeft / track.clientWidth);
      puntos.forEach(function (p, i) {
        var on = i === actual;
        p.classList.toggle("is-active", on);
        p.setAttribute("aria-current", on ? "true" : "false");
      });
    }

    // Cálculo directo, no en requestAnimationFrame: diferirlo dejaba el fade
    // de los carruseles trabado (ver docs/LEARNINGS.md).
    track.addEventListener("scroll", pintar, { passive: true });
    window.addEventListener("resize", pintar);
    pintar();

    // Las imágenes del carril llegan tarde y cambian el ancho total.
    if (window.ResizeObserver) {
      new ResizeObserver(pintar).observe(track);
    }
  });
})();
